import type { BtnListConfig, HeadBtnListConfig } from 'liyu-pc-base/api/typing';
export default (t, { model_app }) => {
  const btn_list: BtnListConfig = [
    {
      name: '修改',
      model_kind: 'custom_component',
      type: 'dropdown',
      clazz: 'primary',
      model_config: {
        title: '修改模型配置',
        component: 'syncModelTypeConfig',
        init_data: {
          form_type: 'edit',
          model_app: model_app,
        },
      },
    },
  ];
  const head_btn_list: HeadBtnListConfig = [
    {
      name: '新建配置',
      model_kind: 'custom_component',
      type: 'dropdown',
      clazz: 'primary',
      model_config: {
        title: '新建模型配置',
        component: 'syncModelTypeConfig',
        init_data: {
          form_type: 'create',
          model_app: model_app,
        },
      },
    },
  ];
  return {
    head_btn_list: head_btn_list,
    btn_list: btn_list,
    is_operation: [false, false, true, true],
  };
};
